var map = {
	"./apple-touch-icon": 9,
	"./apple-touch-icon-114x114": 10,
	"./apple-touch-icon-114x114.png": 10,
	"./apple-touch-icon-120x120": 11,
	"./apple-touch-icon-120x120.png": 11,
	"./apple-touch-icon-144x144": 12,
	"./apple-touch-icon-144x144.png": 12,
	"./apple-touch-icon-152x152": 13,
	"./apple-touch-icon-152x152.png": 13,
	"./apple-touch-icon-180x180": 14,
	"./apple-touch-icon-180x180.png": 14,
	"./apple-touch-icon-57x57": 15,
	"./apple-touch-icon-57x57.png": 15,
	"./apple-touch-icon-72x72": 16,
	"./apple-touch-icon-72x72.png": 16,
	"./apple-touch-icon-76x76": 17,
	"./apple-touch-icon-76x76.png": 17,
	"./apple-touch-icon.png": 9,
	"./favicon": 18,
	"./favicon.ico": 47,
	"./favicon.png": 18,
	"./header-logo": 19,
	"./header-logo.webp": 19,
	"./item-placeholder": 20,
	"./item-placeholder.jpg": 20,
	"./navbar-logo": 7,
	"./navbar-logo.png": 7,
	"./navbar-logo.webp": 48,
	"./prando-shop": 21,
	"./prando-shop.jpg": 21,
	"./social_preview": 22,
	"./social_preview.jpg": 22,
	"./social_preview_default": 23,
	"./social_preview_default.jpg": 23,
	"./start_footer": 24,
	"./start_footer.webp": 24,
	"./start_footer_default": 25,
	"./start_footer_default.webp": 25,
	"./start_header": 26,
	"./start_header.webp": 26,
	"./start_header_default": 27,
	"./start_header_default.webp": 27,
	"./static-1": 28,
	"./static-1.jpg": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;